var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Watch, Vue } from 'vue-property-decorator';
import FileUpload from 'vue-upload-component';
import Cropper from 'cropperjs';
import Compressor from 'compressorjs';
import { $ } from '../../simpli';
import { Request, UploadConfig } from '../../app';
import { Helper } from '../../main';
/**
 * This class should be used as an extended class
 * Use whenever it is necessary to use the upload system
 */
var MixinUpload = /** @class */ (function (_super) {
    __extends(MixinUpload, _super);
    function MixinUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // references
        _this.UPLOAD_REF = 'upload';
        _this.CROPPER_REF = 'cropper';
        // configuration
        _this.UPLOAD_CONFIG = new UploadConfig();
        _this.COMPRESS_CONFIG = UploadConfig.compressedImageStandard;
        _this.USE_CROP = false;
        _this.files = [];
        _this.cache = [];
        _this.cropper = null;
        _this.shown = false;
        _this.cropperMode = false;
        return _this;
    }
    /**
     * Event when the upload inputs a file
     * Do nothing unless it is implemented by the child
     */
    MixinUpload.prototype.onUploadReady = function () {
        /**/
    };
    /**
     * Event when the upload starts
     * Do nothing unless it is implemented by the child
     */
    MixinUpload.prototype.onUploadStart = function () {
        /**/
    };
    /**
     * Event when the upload ends
     * Do nothing unless it is implemented by the child
     */
    MixinUpload.prototype.onUploadEnd = function (urls) {
        /**/
    };
    MixinUpload.prototype.extension = function (file) {
        if (this.files.length) {
            var str = file.name;
            var match = /^(?:[a-zA-Z0-9\s_\\.\-():])+(\..\w+)$/g.exec(str);
            return (match && match[1]) || '';
        }
        return '';
    };
    Object.defineProperty(MixinUpload.prototype, "resources", {
        get: function () {
            var _this = this;
            return this.files.map(function (file) {
                var params = {
                    fileName: "" + Helper.uid() + _this.extension(file),
                };
                return Request.get(_this.UPLOAD_CONFIG.endpoint, { params: params })
                    .asString()
                    .getResponse();
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MixinUpload.prototype, "fileError", {
        get: function () {
            var error = false;
            for (var _i = 0, _a = this.files; _i < _a.length; _i++) {
                var file = _a[_i];
                if (file.error)
                    error = file.error;
            }
            return error;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MixinUpload.prototype, "isCompleted", {
        get: function () {
            var status = true;
            for (var _i = 0, _a = this.files; _i < _a.length; _i++) {
                var file = _a[_i];
                if (!file.success)
                    status = false;
            }
            return status && this.files.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MixinUpload.prototype, "isCropperMode", {
        get: function () {
            return this.cropperMode;
        },
        enumerable: true,
        configurable: true
    });
    MixinUpload.prototype.inputFilter = function (newFile, oldFile, prevent) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(newFile && !oldFile)) return [3 /*break*/, 2];
                        // Before adding a file
                        // Filter system files or hide files
                        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                            return [2 /*return*/, prevent()];
                        }
                        // Filter php html js file
                        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                            return [2 /*return*/, prevent()];
                        }
                        if (!(newFile.file && newFile.type.substr(0, 6) === 'image/')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.compressImage(newFile)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                            // Create a blob field
                            newFile.blob = URL.createObjectURL(newFile.file);
                            // Thumbnails
                            newFile.thumb = '';
                            if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                                newFile.thumb = newFile.blob;
                            }
                        }
                        return [2 /*return*/, 1];
                }
            });
        });
    };
    MixinUpload.prototype.inputFile = function (newFile, oldFile) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, minSize, size, UPLOAD_REF, component;
            return __generator(this, function (_b) {
                _a = this.UPLOAD_CONFIG, minSize = _a.minSize, size = _a.size;
                UPLOAD_REF = this.UPLOAD_REF;
                component = this.$refs[UPLOAD_REF];
                this.shown = false;
                if (newFile && oldFile) {
                    // update
                    // min size
                    if (newFile.size >= 0 && minSize > 0 && newFile.size < minSize) {
                        component.update(newFile, { error: 'minSize' });
                    }
                    // max size
                    if (newFile.size > size) {
                        component.update(newFile, { error: 'maxSize' });
                    }
                    if (newFile.progress !== oldFile.progress) {
                        // progress
                    }
                    if (newFile.error && !oldFile.error) {
                        // error
                    }
                    if (newFile.success && !oldFile.success) {
                        // success
                    }
                    if (this.USE_CROP && !component.active) {
                        this.cropperMode = true;
                    }
                }
                if (!newFile && oldFile) {
                    // remove
                    if (oldFile.success && oldFile.response.id) {
                        /**/
                    }
                    this.exitCropperMode();
                }
                return [2 /*return*/];
            });
        });
    };
    MixinUpload.prototype.compressImage = function (newFile) {
        return __awaiter(this, void 0, void 0, function () {
            var compress, component, blob, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        compress = function (file, options) {
                            return new Promise(function (resolve) {
                                var success = function (file) { return resolve(file); };
                                return new Compressor(newFile.file, __assign({}, options, { success: success }));
                            });
                        };
                        component = this.$refs[this.UPLOAD_REF];
                        newFile.error = 'compressing';
                        return [4 /*yield*/, Helper.sleep(1000)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, compress(newFile.file, this.COMPRESS_CONFIG)];
                    case 3:
                        blob = _a.sent();
                        component.update(newFile, { error: '', file: blob, size: blob.size, type: blob.type });
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        component.update(newFile, { error: e_1.message || 'compress' });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MixinUpload.prototype.validate = function () {
        if (!this.files.length)
            Helper.abort('system.error.noFileSelected');
        if (!this.fileError)
            return;
        if (this.fileError === 'compressing')
            Helper.abort('system.error.fileNotCompressed');
        Helper.abort('system.error.fileSend');
    };
    MixinUpload.prototype.startUpload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, resources, UPLOAD_REF, component, responses, e_2;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.validate();
                        _a = this, resources = _a.resources, UPLOAD_REF = _a.UPLOAD_REF;
                        component = this.$refs[UPLOAD_REF];
                        $.await.init('uploading');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.all(resources)];
                    case 2:
                        responses = _b.sent();
                        responses.forEach(function (resp, i) {
                            var fullUrl = resp.data;
                            var url = fullUrl.split('?')[0];
                            // Define PUT Method URL address of each file
                            _this.files[i].putAction = fullUrl;
                            // Store the url link of the uploaded file
                            _this.cache.push(url);
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _b.sent();
                        $.await.error('uploading');
                        throw e_2;
                    case 4:
                        this.onUploadStart();
                        component.active = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    MixinUpload.prototype.removeUploadFile = function (file) {
        var component = this.$refs[this.UPLOAD_REF];
        if (component) {
            component.remove(file);
        }
    };
    MixinUpload.prototype.exitCropperMode = function () {
        this.cropperMode = false;
    };
    MixinUpload.prototype.resetUpload = function () {
        this.files = [];
        this.cache = [];
        this.exitCropperMode();
    };
    MixinUpload.prototype.triggerEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var component, el;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.shown = true;
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        component = this.$refs[this.UPLOAD_REF];
                        if (component) {
                            el = component.$el.getElementsByTagName('label')[0];
                            el.click();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MixinUpload.prototype.completedEvent = function (status) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (status) {
                    $.await.done('uploading');
                    this.onUploadEnd(this.cache);
                }
                return [2 /*return*/];
            });
        });
    };
    MixinUpload.prototype.cropperModeEvent = function (val) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, files, UPLOAD_REF, component, el, oldFile;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!val) {
                            if (this.cropper) {
                                this.cropper.destroy();
                                this.cropper = null;
                            }
                            return [2 /*return*/];
                        }
                        _a = this, files = _a.files, UPLOAD_REF = _a.UPLOAD_REF;
                        component = this.$refs[UPLOAD_REF];
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _b.sent();
                        el = this.$refs[this.CROPPER_REF];
                        if (!el)
                            return [2 /*return*/];
                        oldFile = files[0];
                        this.cropper = new Cropper(el, {
                            aspectRatio: 1,
                            viewMode: 1,
                            crop: function () {
                                // @ts-ignore
                                var canvas = this.cropper.getCroppedCanvas();
                                var binStr = atob(canvas.toDataURL(oldFile.type).split(',')[1]);
                                var arr = new Uint8Array(binStr.length);
                                for (var i = 0; i < binStr.length; i++) {
                                    arr[i] = binStr.charCodeAt(i);
                                }
                                var file = new File([arr], oldFile.name, { type: oldFile.type });
                                component.update(oldFile.id, {
                                    file: file,
                                    type: file.type,
                                    size: file.size,
                                });
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Watch('isCompleted'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", Promise)
    ], MixinUpload.prototype, "completedEvent", null);
    __decorate([
        Watch('cropperMode'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", Promise)
    ], MixinUpload.prototype, "cropperModeEvent", null);
    MixinUpload = __decorate([
        Component({
            components: { FileUpload: FileUpload },
        })
    ], MixinUpload);
    return MixinUpload;
}(Vue));
export { MixinUpload };
//# sourceMappingURL=MixinUpload.js.map